import React from 'react';

const TR = (props) => {
  return <tr {...props}>{props.children}</tr>;
};

export default TR;
